<template>
  <v-container fluid>
    <div>
      <!-- Automatically updated by .gitlab-ci.yml -->
      Branch: demo/1.9.1-RC1<br />
      Commit: ebfd787a<br />
      Build Date: 2025-02-20T02:52:03Z
    </div>
  </v-container>
</template>

<script>
/* eslint-disable indent */
  export default {
    name: 'Version'
  };
</script>
<style scoped>
  img {
    height: 15vh;
  }
</style>



// WEBPACK FOOTER //
// version.vue